import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LoginInfoInStorage, UserInfoService} from '../user-info.service';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject} from 'rxjs';
import {HttpParams} from '@angular/common/http';

export interface LoginRequestParam {
    username: string;
    password: string;
}

@Injectable()
export class LoginService {

    public landingPage: string = this.appConfig.dashboard_url;
    per = '';
    roles= '';
    regions = '';

    constructor(
        private router: Router,
        private userInfoService: UserInfoService,
        private apiRequest: ApiRequestService,
        private appConfig: AppConfig
    ) {
    }


    getToken(username: string, password: string): Observable<any> {
        const me = this;

        const bodyData: LoginRequestParam = {
            'username': username,
            'password': password,
        };
        /*
            Using BehaviorSubject instead of Subject
            In Angular services are initialized before the components, if any component is
            subscribing, it will only receive events which are executed after subscription.
            therefore if you put a syncronize next() in the service, the component wont get it.

            A BehaviourSubject will always provide the values wheather the subscription happened after or before event

        */

        const loginDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt
        let loginInfoReturn: LoginInfoInStorage; // Object that we want to send back to Login Page

        this.apiRequest.post(this.appConfig.login_url, bodyData)
            .subscribe(jsonResp => {
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.user.webAllowed === true) {
                        // Create a success object that we want to send back to login page
                        loginInfoReturn = {
                            'success': true,
                            'message': jsonResp.message,
                            'landingPage': this.landingPage,
                            'user': {
                                'userId': jsonResp.user.id,
                                'mobile': jsonResp.user.mobile,
                                'displayName': jsonResp.user.name,
                                'token': jsonResp.token,
                                'refreshToken': jsonResp.refreshToken,
                                'roles': jsonResp.user.roles,
                                'regions': jsonResp.user.regions,
                                'webAllowed': jsonResp.user.webAllowed
                            }
                        };
                        // store username and jwt token in session storage to keep user logged in between page refreshes
                        this.userInfoService.storeUserInfo(JSON.stringify(loginInfoReturn.user));
                        
                        for (let i = 0; i < jsonResp.user.regions.length; i++) {
                            this.regions = this.regions + jsonResp.user.regions[i].id + ',';
                        }
                        this.userInfoService.setRegion(this.regions.substring(0, this.regions.length - 1));
                        console.log('regions' , this.regions);

this.roles = '';
                        for (let i = 0; i < jsonResp.user.roles.length; i++) {
                            this.roles = this.roles + jsonResp.user.roles[i].id + ',';
                            console.log('user role inner' , jsonResp.user.roles);
                        }
                        this.userInfoService.setRole(this.roles.substring(0, this.roles.length - 1));
                                 console.log('role check' + this.roles);
                        this.getLogin(jsonResp.user.id)
                            .subscribe(resp => {
                                for (let i = 0; i < resp.data.length; i++) {
                                    this.per = this.per +resp.data[i].permissions + ','
                                }
                                this.userInfoService.setPermission(this.per.substring(0, this.per.length - 1));
                                console.log('pers check' + this.per);

                            });
                    } else {
                        // Create a faliure object that we want to send back to login page
                        loginInfoReturn = {
                            'success': false,
                            'message': jsonResp.message,
                            'landingPage': '/auth/login'
                        };
                        this.router.navigate(['/auth/login']);
                    }
                    loginDataSubject.next(loginInfoReturn);
                },
                err => {
                    loginInfoReturn = {
                        'success': false,
                        'message': err.errorCode + ' >>> ' + err.message + '[' + err.status + ']',
                        'landingPage': '/auth/login'
                    };
                    loginDataSubject.next(loginInfoReturn);
                });

        return loginDataSubject;
    }

    clearDetails(){
        this.per="";
        this.roles="";
        this.regions="";
    }

    logout(navigatetoLogout = true): void {
        sessionStorage.clear();
        this.userInfoService.removeUserInfo();
        this.userInfoService.removeRoles();
        this.clearDetails();
        if (navigatetoLogout) {
            this.router.navigate(['logout']);
        }
    }

    getLogin(id: number): Observable<any> {
        return this.apiRequest.get(this.appConfig.user_url + '/' + id + '/role-permissions');

    }

    getColdStoreBasedOnId(pageNumber: any, limit: any, id: number) {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return this.apiRequest.get(this.appConfig.user_url + '/' + id + '/cold-stores', params)
    }

    getOperatorsBasedOnId(pageNumber: any, limit: any, id: number) {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return this.apiRequest.get(this.appConfig.user_url + '/' + id + '/operators', params)
    }
}
